import { hasUserInteracted } from './hasUserInteracted';

export function focusElement(element?: HTMLElement | null) {
  if (hasUserInteracted()) {
    element?.focus();
  }
}
